import { CONFIG } from '../../../config';

const measurementId = CONFIG.GA4_MEASUREMENT_ID;

type GA4Ids = {
  ga4_session_id?: number;
  ga4_session_number?: number;
  ga4_client_id?: string;
};

const GET_GA4_IDS_TIMEOUT = 100;

export const getGA4Ids = () =>
  new Promise<GA4Ids>(resolve => {
    const ids: GA4Ids = {};

    if (!measurementId || !window.ga4) return resolve(ids);

    const areAllIdsPresent = () =>
      ids.ga4_session_id != null && ids.ga4_session_number != null && ids.ga4_client_id != null;

    window.ga4(
      'get',
      measurementId,
      'session_id',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      session_id => {
        ids.ga4_session_id = typeof session_id === 'number' ? session_id : Number(session_id);
        if (areAllIdsPresent()) resolve(ids);
      }
    );
    window.ga4(
      'get',
      measurementId,
      'session_number',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      session_number => {
        ids.ga4_session_number =
          typeof session_number === 'number' ? session_number : Number(session_number);
        if (areAllIdsPresent()) resolve(ids);
      }
    );
    window.ga4(
      'get',
      measurementId,
      'client_id',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      client_id => {
        ids.ga4_client_id = String(client_id);
        if (areAllIdsPresent()) resolve(ids);
      }
    );

    setTimeout(() => resolve(ids), GET_GA4_IDS_TIMEOUT);
  });
